import React, { useState, useEffect } from 'react';
import { Box, Typography, Skeleton, Tooltip, IconButton } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { aiApi } from '../services/hrmsApi';
import { useChatContext } from '../context/ChatContext';

const STUBS = {
  'workforce-pulse':    'Headcount stable at 1,063. Sales attrition is trending upward — review compensation benchmarks before the Q3 budget lock.',
  'finance-budget':     'Payroll tracking 3.2% above monthly budget. Claims within seasonal norms. Flag IT contract renewals for Q3 leadership review.',
  'operations':         'Weekly attendance averaged 87.4%. Early-leavers in Operations increased 12% — monitor for team burnout risk.',
  'talent-performance': 'KPI completion at 78%, above the 75% target. 3 employees eligible for promotion review based on current 9-box positioning.',
};

export default function TabAISummary({ tabKey }) {
  const [text,    setText]    = useState('');
  const [loading, setLoading] = useState(true);
  const { openWithMessage } = useChatContext();

  useEffect(() => {
    setLoading(true);
    setText('');
    aiApi.getTabSummary(tabKey)
      .then((res) => { setText(res?.text || ''); setLoading(false); })
      .catch(() => { setText(STUBS[tabKey] || ''); setLoading(false); });
  }, [tabKey]);

  if (!loading && !text) return null;

  return (
    <Box sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5,
      bgcolor: 'action.hover', borderRadius: 2, px: 2, py: 1.25, mb: 2,
    }}>
      <AutoAwesome sx={{ fontSize: 16, color: 'primary.main', mt: 0.3, flexShrink: 0 }} />
      <Box sx={{ flex: 1 }}>
        {loading ? (
          <Skeleton width="72%" height={18} />
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {text}
          </Typography>
        )}
      </Box>
      {!loading && text && (
        <Tooltip title="Ask AI to expand on this">
          <IconButton
            size="small"
            onClick={() => openWithMessage(`Expand on this HR insight: "${text}"`)}
            sx={{ flexShrink: 0, color: 'primary.main', opacity: 0.55, '&:hover': { opacity: 1 }, p: 0.5 }}
          >
            <AutoAwesome sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
